/**
 * Created by olga on 28.05.2025
 */

Map2dDecorator.prototype.getLayerId = function () {
    if (this.layer !== undefined) {
        return this.layer;
    }

    return Map2d.LAYER_UNITS;
};